import { render, staticRenderFns } from "./RoomChange.vue?vue&type=template&id=256ec521&"
import script from "./RoomChange.vue?vue&type=script&lang=js&"
export * from "./RoomChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports